import React from 'react';
import { RefreshCw, Download, Loader2, Printer } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const TransactionReportHeader = ({
  onRefresh,
  onExport,
  onPrintSummary,
  isLoading,
  isExporting,
  isPrinting
}) => {
  const { t } = useTranslation();

  return (
    <div className="mb-8">
      <div className="md:flex items-center justify-between mb-4">
        <div>
          <h1 className="text-3xl font-bold text-slate-900 mb-2">
            {t('transactions.title')}
          </h1>
          <p className="text-slate-600">
            {t('transactions.description')}
          </p>
        </div>
        <div className="sm:flex items-center gap-3 mt-2">
          <button 
            onClick={onRefresh}
            disabled={isLoading}
            className="flex items-center gap-2 px-3 py-2 mb-2 text-sm border border-slate-300 rounded-lg hover:bg-slate-50 transition-colors duration-200 disabled:opacity-50"
          >
            {isLoading ? (
              <Loader2 size={16} className="animate-spin" />
            ) : (
              <RefreshCw size={16} />
            )}
            <span>{t('transactions.refresh')}</span>
          </button>
          {/* <button 
            onClick={onExport}
            disabled={isExporting}
            className="flex items-center gap-2 px-4 py-2 mb-2 bg-white border border-slate-300 rounded-lg hover:bg-slate-50 transition-colors duration-200 disabled:opacity-50"
          >
            {isExporting ? (
              <Loader2 size={16} className="animate-spin" />
            ) : (
              <Download size={16} />
            )}
            <span>{isExporting ? t('transactions.exporting') : t('transactions.export')}</span>
          </button>
          <button 
            onClick={onPrintSummary}
            disabled={isPrinting}
            className="flex items-center gap-2 px-4 py-2 mb-2 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition-colors duration-200 disabled:opacity-50"
          >
            {isPrinting ? (
              <Loader2 size={16} className="animate-spin" />
            ) : (
              <Printer size={16} />
            )}
            <span>{isPrinting ? t('transactions.printing') : t('transactions.print')}</span>
          </button> */}
        </div>
      </div>
    </div>
  );
};
